import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  ElementRef,
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormToolsService, LocaleDataService } from "../core";
import { NotifyService } from "../notify/notify.service";
import { Locale } from "@atenea-cms";

@Component({
  selector: "atn-crud-box",
  templateUrl: "./crud-box.component.html",
  styleUrls: ["./crud-box.component.scss"],
  animations: [
    trigger("changeState", [
      state("hide", style({ opacity: 0 })),

      transition(":enter", [
        style({ opacity: 0 }),
        animate("700ms ease-in-out", style({ opacity: 1 })),
      ]),

      transition("* => hide", animate("700ms ease-in-out")),
    ]),
  ],
})
export class CrudBoxComponent {
  @Input() modelName: string = null;
  @Input() id: string = null;
  @Input() loading: boolean = false;
  @Input() dataService: any;
  @Input() form: FormGroup;
  @Input() transformFormValueBeforeLoad: any;
  @Input() transformFormValueBeforeSave: any;
  @Input() saveOnly: boolean = false;
  @Input() duplicateOption: boolean = true;
  @Input() translateFromLocaleOption: boolean = true;
  @Input() confirmToRemove: boolean = true;
  @Input() removeQuestion: string = "¿Esta seguro de que desea borrarlo?";

  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @Output() onDuplicate: EventEmitter<string> = new EventEmitter();
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onSave: EventEmitter<string> = new EventEmitter();

  @ViewChild("container") container: ElementRef;

  currentHeight: number;
  state: string;

  constructor(
    private ft: FormToolsService,
    private notify: NotifyService,
    private localeDataService: LocaleDataService
  ) {}

  @HostListener("document:keydown", ["$event"])
  detectShortcut(e) {
    if (e.ctrlKey && e.altKey) {
      if (this.saveOnly && e.keyCode !== 83) {
        return;
      }

      if ([87, 82, 68, 83].indexOf(e.keyCode) !== -1) {
        e.preventDefault();

        setTimeout(() => {
          switch (e.keyCode) {
            case 87: {
              // Ctrl + Alt + W}
              this.back();
              break;
            }
            case 82: {
              // Ctrl + Alt + R
              if (this.id) {
                this.remove();
              }
              break;
            }
            case 68: {
              // Ctrl + Alt + D
              if (this.id && this.duplicateOption) {
                this.duplicate();
              }
              break;
            }
            case 83:
              this.save();
              break; // Ctrl + Alt + S
          }
        }, 300);
      }
    }
  }

  save() {
    if (this.form.valid === false) {
      this.ft.showFormErrors(this.form);
      this.notify.warning("Hay errores en el formulario");
      return;
    }

    const cs = window.getComputedStyle(this.container.nativeElement);
    this.currentHeight =
      this.container.nativeElement.offsetHeight -
      parseFloat(cs.paddingTop) -
      parseFloat(cs.paddingBottom);

    const value = this.transformFormValueBeforeSave
      ? this.transformFormValueBeforeSave(this.form)
      : this.form.value;
    // Eliminamos _id vacíos para que Mongo no los guarde tal cual y los genere
    const removeId = (item: Object) => {
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          const child = item[key];
          if (key === "_id" && !child) {
            delete item[key];
          }

          if (typeof item[key] === "object") {
            removeId(child);
          }
        }
      }
    };

    removeId(value);

    this.loading = true;

    this.dataService.save(value).subscribe((savedItem) => {
      setTimeout(() => {
        this.loading = false;

        savedItem = this.transformFormValueBeforeLoad
          ? this.transformFormValueBeforeLoad(savedItem)
          : savedItem;

        this.form.patchValue(savedItem);
        this.onSave.emit(savedItem._id);

        this.notify.success("El registro ha sido guardado correctamente");
      }, 500);
    });
  }

  duplicate() {
    this.loading = true;

    this.dataService.duplicate(this.form.value._id).subscribe((savedItem) => {
      setTimeout(() => {
        this.loading = false;
        this.onDuplicate.emit(savedItem._id);
        this.notify.success("El registro ha sido duplicado correctamente");
      }, 500);
    });
  }

  remove() {
    if (
      !this.confirmToRemove ||
      (this.confirmToRemove && confirm(this.removeQuestion))
    ) {
      this.loading = true;

      this.dataService.remove(this.id).subscribe(() => {
        setTimeout(() => {
          this.loading = false;
          this.onRemove.emit(this.id);
          this.notify.success("El registro ha sido borrado correctamente");
        }, 500);
      });
    }
  }

  back() {
    if (this.form.dirty && !confirm("¿Está seguro de descartar los cambios?")) {
      return;
    }

    this.state = "hide";
    setTimeout(() => {
      this.onBack.emit(null);
    }, 700);
  }

  get othersLocales() {
    return this.localeDataService
      .getLocalesAvailable()
      .filter(
        (locale) =>
          locale.code !== this.localeDataService.getCurrentLocale().code
      );
  }

  getDataFromLocale(locale: Locale) {
    this.loading = true;
    this.dataService.getDataForLocale(this.id, locale).subscribe((item) => {
      this.notify.success(
        "Se ha obtenido la información del idioma seleccionado"
      );
      this.form.patchValue(item);
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/crud-box/crud-box.component.ts